import VueRouter from 'vue-router'

import Index from '@views/index.vue'
import Login from '@views/login.vue'
import NoFound from '@views/404.vue'
import Browse from '@views/browse.vue'
import Menu from '@views/menu.vue'


// 懒加载 
const My = () =>
    import ('@views/my.vue')

const routes = [{
        path: "/",
        name: "Index",
        component: Index,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/index",
        name: "Index",
        component: Index,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            noneHeader: false,
        }
    },
    {
        path: "/my",
        name: "My",
        component: My,
        meta: {
            noneHeader: false,
        }
    },
    {
        path: '/browse',
        name: "Browse",
        component: Browse,
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/menu-*',
        name: 'Menu',
        component: Menu,
        meta: {
            keepAlive: true,
            noFixedHeader: true
        }
    },
    {
        path: '/notFound',
        name: "404",
        component: NoFound,
    },
    {
        path: '*',
        name: "404",
        component: NoFound,
    },
];


export default new VueRouter({
    mode: 'history',
    base: "",
    routes, // (缩写) 相当于 routes: routes
    // eslint-disable-next-line
    scrollBehavior(to, from, savedPosition) {

        if (to.path.includes('menu-')) {
            document.body.scrollTop = document.documentElement.scrollTop = 100
        } else if (to.path.includes('login')) {
            document.body.scrollTop = document.documentElement.scrollTop = 0
        } else {
            // 始终滚动到顶部
            document.body.scrollTop = document.documentElement.scrollTop = 0
        }
        return { top: 0 }
    },
})